<ng-container *ngIf="isAppEnabled && product$ | async as product; else notEnabled">
  <div class="full-height mobile-padding step-pre-qualification-container">
    <pre-qualification
      [cardName]="getProductName(product)"
      [productCode]="product.id"
      [locale]="lang"
      [submitted]="(submitted$ | async)!"
      [isMobile$]="isMobile$"
    ></pre-qualification>

    <div class="navigation step-pre-qual-nav">
      <button rbcCTA="secondary" (click)="back()">
        {{ "GLOBAL.BACK" | translate }}
      </button>
      <button rbcCTA="primary" (click)="continue()">
        {{ "GLOBAL.NEXT" | translate }}
      </button>
    </div>
  </div>
</ng-container>

<ng-template #notEnabled>
  <div class="coming-soon mt-64">
    <h1 class="temp-tile">
      {{ "TEMP.READY-TO-APPLY" | translate }}
    </h1>
    <div class="temp-contact-row">
      <div class="temp-contact-col">
        <p>{{ "TEMP.CALL-BUSINESS-HELPLINE" | translate }}</p>
        <div>
          <rbc-icon size="m" color="blue" name="phone"></rbc-icon>
        </div>
        <a href="tel:+18557043168">{{ "TEMP.HELPLINE-NUMBER" | translate }}</a>
      </div>
      <div class="temp-contact-col">
        <p>{{ "TEMP.LOCATE-BRANCH" | translate }}</p>
        <div>
          <rbc-icon size="m" color="blue" name="map-marker"></rbc-icon>
        </div>
        <a [href]="'TEMP.BRANCH-FINDER-URL' | translate">{{ "TEMP.FIND-BRANCH" | translate }}</a>
      </div>
    </div>
  </div>
</ng-template>
